import useHehmApi from 'hooks/useHehmApi'

import { HehmDeviceEquipment } from 'types/HehmDevice'

const useHehmDeviceEquipment = (deviceId: string) => {
  const path = `/devices/${deviceId}/equipment`
  const {
    hehmData,
    isHehmDataLoaded: isHehmDeviceEquipmentLoaded
  } = useHehmApi(path)

  const hehmDeviceEquipment = hehmData as HehmDeviceEquipment

  return {
    hehmDeviceEquipment,
    isHehmDeviceEquipmentLoaded
  }
}

export default useHehmDeviceEquipment
